import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService } from '../services/dataService.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-newspost',
  templateUrl: './newspost.component.html',
  styleUrls: ['./newspost.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewspostComponent implements OnInit {

    static componentName = 'NewspostComponent';
    post: any;
    slug: any;

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
    ) {
        this.slug = this.route.snapshot.params.slug;
    }

    getPost(): void {
        this.dataService.getPost('/' + this.slug)
            .subscribe(res => this.post = res);
    }

    ngOnInit() {
        this.getPost();
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/newspost/newspost.component.ts